"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOwnerMemberInfo = exports.updateUser = exports.emailBind = exports.submitInviteCode = exports.linkInviteEmail = exports.validateEmail = exports.getUserCanLogout = exports.getUserMe = void 0;
const axios_1 = __importDefault(require("axios"));
const Url = __importStar(require("../../shared/api/url"));
/**
 *
 * Get My Info
 *
 * @param locateIdMap
 * @param filter
 * @param headers
 * @returns
 */
function getUserMe(locateIdMap = { spaceId: '', nodeId: '' }, filter = false, headers) {
    return axios_1.default.get(Url.USER_ME, {
        params: Object.assign(Object.assign({}, locateIdMap), { filter }),
        headers,
    });
}
exports.getUserMe = getUserMe;
/**
 * Check user can delete or close
 * @returns
 */
function getUserCanLogout() {
    return axios_1.default.get(Url.USER_CAN_LOGOUT);
}
exports.getUserCanLogout = getUserCanLogout;
/**
 *
 * Space - check if the user's email is the same as the specified email
 * @param email
 * @returns
 */
function validateEmail(email) {
    return axios_1.default.post(Url.EMAIL_VALIDATE, { email });
}
exports.validateEmail = validateEmail;
/**
 *
 * Space - binding the invited email
 *
 * @param spaceId
 * @param email
 * @returns
 */
function linkInviteEmail(spaceId, email) {
    return axios_1.default.post(Url.LINK_INVITE_EMAIL, { spaceId, email });
}
exports.linkInviteEmail = linkInviteEmail;
/**
 * invite code reward
 */
function submitInviteCode(inviteCode) {
    return axios_1.default.post(Url.INVITE_CODE_REWARD, { inviteCode });
}
exports.submitInviteCode = submitInviteCode;
/**
 * Space - check if the user has bound the email
 */
function emailBind() {
    return axios_1.default.get(Url.EMAIL_BIND);
}
exports.emailBind = emailBind;
/**
 * Update (Edit) the user info
 * @param info
 */
function updateUser(info) {
    return axios_1.default.post(Url.UPDATE_USER, info);
}
exports.updateUser = updateUser;
/**
 * Edit Member Info and nickname
 * @param memberName nickname
 */
function updateOwnerMemberInfo(memberName) {
    return axios_1.default.post(Url.MEMBER_UPDATE, { memberName });
}
exports.updateOwnerMemberInfo = updateOwnerMemberInfo;
//# sourceMappingURL=api.user.js.map